const getRootMasterplans = masterplans => {
  let rootMasterplans = []
  if (masterplans)
    masterplans.forEach(item => {
      if (item.parentId === 0) {
        rootMasterplans.push(item)
      }
    })
  return rootMasterplans
}

export default {
  getRootMasterplans
}
